import {
    Stack, TextField, FormControl, InputLabel, Select, MenuItem, Tooltip, IconButton, Button
} from '@mui/material';
import { Add, Refresh } from '@mui/icons-material';

export default function AdminFilters({
                                         search, role, status, onChange, onRefresh, onCreate
                                     }) {
    return (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" justifyContent="space-between">
            <Stack direction="row" spacing={2} alignItems="center" flex={1}>
                <TextField
                    label="Rechercher (email, nom, prénom)"
                    value={search}
                    onChange={(e) => onChange({ search: e.target.value, page: 1 })}
                    size="small"
                    fullWidth
                />
                <FormControl size="small" sx={{ minWidth: 160 }}>
                    <InputLabel>Rôle</InputLabel>
                    <Select value={role} label="Rôle" onChange={(e) => onChange({ role: e.target.value, page: 1 })}>
                        <MenuItem value="all">Tous</MenuItem>
                        <MenuItem value="admin">Admin</MenuItem>
                        <MenuItem value="comptable">Comptable</MenuItem>
                    </Select>
                </FormControl>
                <FormControl size="small" sx={{ minWidth: 160 }}>
                    <InputLabel>Statut</InputLabel>
                    <Select value={status} label="Statut" onChange={(e) => onChange({ status: e.target.value, page: 1 })}>
                        <MenuItem value="all">Tous</MenuItem>
                        <MenuItem value="active">Actifs</MenuItem>
                        <MenuItem value="inactive">Inactifs</MenuItem>
                    </Select>
                </FormControl>
            </Stack>
            <Stack direction="row" spacing={1}>
                <Tooltip title="Rafraîchir"><IconButton onClick={onRefresh}><Refresh /></IconButton></Tooltip>
                <Button variant="contained" startIcon={<Add />} onClick={onCreate}>Nouvel Utilisateur</Button>
            </Stack>
        </Stack>
    );
}
